(function(window, cssClassesFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.cssClasses = cssClassesFactory();
})(this, function() {
   'use strict';

   var _smartPlayerNamespace = 'tsc-smartplayer';
   var _largerProgressBar = 'larger-progress-bar';
   var _disabled = 'disabled-button';
   var _hide = 'hide';
   var _fullscreenMode = 'fullscreen-mode';
   var _volumeMutedButtonGlyph = 'volume-muted-button-glyph';
   var _volumeLowButtonGlyph = 'volume-low-button-glyph';
   var _volumeMediumButtonGlyph = 'volume-medium-button-glyph';
   var _volumeHighButtonGlyph = 'volume-high-button-glyph';
   var _playButtonGlyph = 'play-button-glyph';
   var _pauseButtonGlyph = 'pause-button-glyph';
   var _fullscreenButtonGlyph = 'fullscreen-button-glyph';
   var _fullscreenButtonActiveGlyph = 'fullscreen-button-active-glyph';
   var _fullFrameButtonGlyph = 'full-frame-button-glyph';
   var _fullFrameButtonActiveGlyph = 'full-frame-button-active-glyph';
   var _expandButtonActiveGlyph = 'expand-button-glyph';
   var _audioDescriptionButtonGlyph = 'audio-description-button-glyph';
   var _audioDescriptionButtonActiveGlyph = 'audio-description-button-active-glyph';
   var _closedCaptionButtonGlyph = 'closed-caption-glyph';
   var _closedCaptionNonEnglishButtonGlyph = 'closed-caption-non-en-glyph';
   var _closedCaptionButtonActiveGlyph = 'closed-caption-active-glyph';
   var _closedCaptionNonEnglishButtonActiveGlyph = 'closed-caption-non-en-active-glyph';
   var _tocButtonGlyph = 'toc-button-glyph';
   var _tocButtonActiveGlyph = 'toc-button-active-glyph';
   var _settingsButtonGlyph = 'settings-button-glyph';
   var _settingsButtonActiveGlyph = 'settings-button-active-glyph';
   var _tertiaryButton = 'tertiary-button';
   var _tertiaryButtonActive = 'tertiary-button-active';
   var _generatedPluginContainer = 'generated-plugin-container';
   var _pluginNamedContainerPrefix = 'plugin-';
   var _hotspotVisible = 'hotspot-visible';
   var _screenReaderAlert = 'alert-only';

   return Object.defineProperties({}, {
      smartPlayerNamespace: {value: _smartPlayerNamespace},
      largerProgressBar: {value: _largerProgressBar},
      hide: {value: _hide},
      disabled: {value: _disabled},
      fullscreenMode: {value: _fullscreenMode},
      volumeMutedButtonGlyph: {value: _volumeMutedButtonGlyph},
      volumeLowButtonGlyph: {value: _volumeLowButtonGlyph},
      volumeMediumButtonGlyph: {value: _volumeMediumButtonGlyph},
      volumeHighButtonGlyph: {value: _volumeHighButtonGlyph},
      playButtonGlyph: {value: _playButtonGlyph},
      pauseButtonGlyph: {value: _pauseButtonGlyph},
      fullscreenButtonGlyph: {value: _fullscreenButtonGlyph},
      fullscreenButtonActiveGlyph: {value: _fullscreenButtonActiveGlyph},
      fullFrameButtonGlyph: {value: _fullFrameButtonGlyph},
      fullFrameButtonActiveGlyph: {value: _fullFrameButtonActiveGlyph},
      expandButtonGlyph: {value: _expandButtonActiveGlyph},
      audioDescriptionButtonGlyph: {value: _audioDescriptionButtonGlyph},
      audioDescriptionButtonActiveGlyph: {value: _audioDescriptionButtonActiveGlyph},
      closedCaptionButtonGlyph: {value: _closedCaptionButtonGlyph},
      closedCaptionNonEnglishButtonGlyph: {value: _closedCaptionNonEnglishButtonGlyph},
      closedCaptionButtonActiveGlyph: {value: _closedCaptionButtonActiveGlyph},
      closedCaptionNonEnglishButtonActiveGlyph: {value: _closedCaptionNonEnglishButtonActiveGlyph},
      tocButtonGlyph: {value: _tocButtonGlyph},
      tocButtonActiveGlyph: {value: _tocButtonActiveGlyph},
      settingsButtonGlyph: {value: _settingsButtonGlyph},
      settingsButtonActiveGlyph: {value: _settingsButtonActiveGlyph},
      tertiaryButton: {value: _tertiaryButton},
      tertiaryButtonActive: {value: _tertiaryButtonActive},
      generatedPluginContainer: {value: _generatedPluginContainer},
      pluginNamedContainerPrefix: {value: _pluginNamedContainerPrefix},
      hotspotVisible: {value: _hotspotVisible},
      screenReaderAlert: {value: _screenReaderAlert}
   });
});

